import axios, { AxiosInstance } from "axios";
import { type } from "os";
import { loadAppConfig } from "../../../config/app-config";
// import { serviceBackendUser } from "../../../drivers/service/axiosBackend";

function getCookie(key: string) {
  var b = document.cookie.match("(^|;)\\s*" + key + "\\s*=\\s*([^;]+)");
  return b ? b.pop() : "";
}

export interface IFilter {
  type: string;
  text: string;
}
export interface ITeamService {
  getSubOrganize: () => Promise<string>;
  getOaOrganize: () => Promise<string>;
  getUser: (fillterData: IFilter) => Promise<string>;
  getProfileOaById: (data: any) => Promise<string>;

  getAllDaily: () => Promise<any>;
  addDaily: (data: any) => Promise<string>;
  deleteDaily: (data: any) => Promise<string>;
  getDailyById: (data: any) => Promise<string>;
  updateDailyById: (id: any, data: any) => Promise<string>;
}

export const BatchProcessServiceDailyFile = (
  serviceBackendUser: any,
): ITeamService => ({
  updateDailyById: async (id, data) => {
    const result = await serviceBackendUser.put(
      `/link/v1/daily-file/${id}`,
      data,
    );
    return result?.data || {};
  },
  getDailyById: async (data) => {
    const result = await serviceBackendUser.get(`/link/v1/daily-file/${data}`);
    return result?.data || {};
  },
  deleteDaily: async (data) => {
    const result = await serviceBackendUser.delete(
      `/link/v1/daily-file/${data}`,
    );
    return result?.data || {};
  },
  addDaily: async (data) => {
    const result = await serviceBackendUser.post(`/link/v1/daily-file`, data);
    return result?.data || {};
  },
  getAllDaily: async () => {
    let headerConfig = {
      headers: { "Access-Control-Allow-Origin": "*" },
    };
    const result = await serviceBackendUser.get(
      `/link/v1/daily-file`,
      headerConfig,
    );
    return result?.data || {};
  },

  getProfileOaById: async (data) => {
    const result = await serviceBackendUser.get(`/oa/getprofileoabyid/${data}`);
    return result?.data || {};
  },
  getSubOrganize: async () => {
    const result = await serviceBackendUser.post("/oa/profile/subGroups", {});
    return result?.data || {};
  },
  getOaOrganize: async () => {
    const result = await serviceBackendUser.post("/oa/organize/roles", {});
    return result?.data || {};
  },
  getUser: async (filter: IFilter) => {
    let data = {};
    if (filter.type != "" && filter.text != "") {
      data = filter;
    }
    const result = await serviceBackendUser.post("/oa/user", data);
    return result?.data || {};
  },
});
